import React from 'react';
import { sortBy } from 'lodash';
import AutoComplete from '../../shared/AutoComplete';

class GroupsAutoComplete extends React.Component {
  constructor(props) {
    super(props);
    this.selectionCallback = this.selectionCallback.bind(this);
  }

  selectionCallback(selection) {
    this.props.updateActiveGroup(selection.id);
    if (this.props.groupsListVisible) {
      this.props.toggleGroupsList();
    }
  }

  render() {
    const { groups } = this.props;

    return (
      <AutoComplete
        placeholder={t('groups.search')}
        searchables={sortBy(groups, 'name')}
        searchableProperty="name"
        defaultSearchableProperty
        selectionCallback={this.selectionCallback}
      />
    );
  }
}

export default GroupsAutoComplete;
